import styled from 'styled-components/macro'
import { ifProp } from 'styled-tools'
import { rem, rgba, mediaMaxWidth } from '../../utils/styles'
import { StyledIcon } from '../SocialIcon/BaseIcon'

const transitionDuration = `${(1000 / 6).toFixed(6)}ms`
const largeWidth = mediaMaxWidth('large')
const focusBg = ifProp('inverted', rgba('white', 0.4), rgba('base', 0.4))

const SocialLink = styled.a`
  display: inline-block;
  border-radius: ${rem(3)};
  padding: 0 ${rem(9)};
  height: ${rem(32)};
  text-decoration: none;
  transition: opacity ${transitionDuration} ease-in;

  @media (max-width: ${largeWidth}) {
    &:first-of-type {
      margin-left: ${rem(-16)};
    }
  }

  &:focus {
    background-color: ${focusBg};
  }

  &:hover ${StyledIcon} {
    opacity: .6;
  }
`

export default SocialLink
